(() => {
  if (!customElements.get('ol-hygiene-slider')) {
    customElements.define('ol-hygiene-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = [...this.querySelectorAll('[data-hygiene-tab]')];
        this.panels = [...this.querySelectorAll('[data-hygiene-panel]')];
        this.index = 0;
        this.tabs.forEach((tab, index) => {
          tab.disabled = false;
          tab.addEventListener('click', () => this.show(index));
          tab.addEventListener('keydown', event => {
            let next = this.index;
            if (event.key === 'ArrowRight') next++;
            else if (event.key === 'ArrowLeft') next--;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault(); this.show(next, true);
          });
        });
        [['[data-hygiene-prev]', -1], ['[data-hygiene-next]', 1]].forEach(([selector, step]) => {
          const button = this.querySelector(selector); button.disabled = this.tabs.length < 2;
          button.addEventListener('click', () => this.show(this.index + step));
        });
        this.show(0);
      }
      show(index, focus = false) {
        if (!this.tabs.length) return;
        this.index = (index + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === this.index)); tab.tabIndex = i === this.index ? 0 : -1; });
        this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
        if (focus) this.tabs[this.index].focus();
      }
    });
  }
  if (!customElements.get('ol-hygiene-product')) {
    customElements.define('ol-hygiene-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return; this.ready = true;
        const select = this.querySelector('[data-hygiene-variant]');
        if (!select) return;
        select.addEventListener('change', () => {
          const selected = select.selectedOptions[0];
          this.querySelector('[data-hygiene-sku]').textContent = selected.dataset.sku || '';
          const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
        });
      }
    });
  }
})();
